import { FormikHelpers } from "formik";
import AtmCompanyForm from "./AtmCompanyForm";
import { useGetAtmCompany } from "./api/getAtmCompany";
import { useEditAtmCompany } from "./api/editAtmCompany";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";


const EditAtmCompany = ({handleCloseModal, atmCompanyId}: EditAtmCompanyProps)  => {
  const getAtmCompanyQuery = useGetAtmCompany({atmCompanyId: atmCompanyId})
  const editAtmCompanyMutation = useEditAtmCompany({data: {}, atmCompanyId});

  const handleSubmit = async (values: IPostEditAtmCompany, { setSubmitting }: FormikHelpers<IPostEditAtmCompany>): Promise<void> => {
    try {
      await editAtmCompanyMutation.mutateAsync({
        data: values,
        atmCompanyId: atmCompanyId
      });
      handleCloseModal();
    }catch(error){
      console.log("values",values)
    }finally{
      setSubmitting(false);
    }
  }

  if (getAtmCompanyQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getAtmCompanyQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση της Εταιρίας.</div>
    )
  }

  return (
    <>
      {!getAtmCompanyQuery.isLoading && getAtmCompanyQuery.data &&
        <AtmCompanyForm initialValues={getAtmCompanyQuery.data} type="edit" onSubmit={handleSubmit} />
      }
    </>
  )
}

interface EditAtmCompanyProps {
  atmCompanyId: number;
  handleCloseModal: () => void;
}

export default EditAtmCompany;